import { $fetch } from 'ofetch';
import { withTenantSchema } from '@/utils/apiHeaders';


export interface AbandonedCartPayload {
    sessionId: string;
    userId?: string;
    items: {
        productId: string;
        quantity: number;
        selectedOptions?: Record<string, string>;
        price: number;
    }[];
    total: number;
    metadata?: Record<string, any>;
}

export const abandonedCartsApiService = {
    async saveCart(cartData: AbandonedCartPayload) {
        const token = localStorage.getItem('auth_token');
        return await $fetch(`${import.meta.env.VITE_API_BASE_URL}/api/ecommerce/abandoned-carts`, {
            method: 'POST',
            headers: withTenantSchema({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            }),
            body: cartData
        });
    },

    async getCartBySession(sessionId: string) {
        const token = localStorage.getItem('auth_token');
        const response = await $fetch.raw(`${import.meta.env.VITE_API_BASE_URL}/api/ecommerce/abandoned-carts/session/${sessionId}`, {
            method: 'GET',
            retry: 0,
            ignoreResponseError: true,
            headers: withTenantSchema({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            }),
        });

        if (response.status === 404) {
            return null;
        }

        return response._data;
    },

    async recoverCart(cartId: string, orderId: string) {
        const token = localStorage.getItem('auth_token');
        return await $fetch(`${import.meta.env.VITE_API_BASE_URL}/api/ecommerce/abandoned-carts/${cartId}/recover`, {
            method: 'PUT',
            headers: withTenantSchema({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            }),
            body: { orderId, recoveryMethod: 'automatic' }
        });
    },

    async deleteCartBySession(sessionId: string) {
        const token = localStorage.getItem('auth_token');
        const response = await $fetch.raw(`abandoned-carts/session/${sessionId}`, {
            baseURL: `${import.meta.env.VITE_API_BASE_URL}/api/ecommerce/`,
            method: 'DELETE',
            retry: 0,
            ignoreResponseError: true,
            headers: withTenantSchema({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            })
        });

        // 404 es válido aquí: si no existe, ya está "eliminado"
        if (response.status === 404) {
            return { success: true, deleted: false };
        }

        return {
            success: response.status >= 200 && response.status < 300,
            deleted: response.status >= 200 && response.status < 300,
        };
    }
};
